import api from '../api';

/**
 * 登録済み帳票の PDF を生成してブラウザにダウンロードさせる
 * @param {'invoices'|'estimates'|'orders'|'deliveries'} resource
 * @param {string|number} documentId
 */
export async function issueDocumentPdf(resource, documentId) {
  if (!documentId) return null;

  const { data: info } = await api.get(`/api/${resource}/${documentId}/pdf`);
  if (!info?.downloadUrl) throw new Error('PDFの生成に失敗しました');

  const res = await api.get(info.downloadUrl, { responseType: 'blob' });
  const url = window.URL.createObjectURL(res.data);
  const a = document.createElement('a');
  a.href = url;
  a.download = info.fileName || `${resource}_${documentId}.pdf`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);

  return info;
}
